import { Reducer, AnyAction } from 'redux';
import * as LoginTypes from 'src/actions/authentication/login/Types';
import * as ProfileTypes from 'src/actions/active-profile/set/Types';
import { RootState } from './RootReducer';

export const globalReducer: Reducer<Partial<RootState>> = (state: RootState, action: AnyAction) => {
  switch (action.type) {
    case ProfileTypes.SET_ACTIVE_PROFILE:
      return {
        ...state,
        indexInvestments: undefined,
        getInvestment: undefined,
        getFormalization: undefined,
        getInvestorDeck: undefined,
        indexPersonInterestedProjects: undefined,
        indexPersonInvestedProjects: undefined,
        getProjectInvested: undefined,
        getProjectInterested: undefined,
        getPayment: undefined,
      };
    case LoginTypes.LOGOUT:
      return {
        router: state.router,
        indexProjects: state.indexProjects,
        getMetrics: state.getMetrics,
        getProject: state.getProject,
      };
    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducers/Global.reducer.tsx